(() => {
  if (window.spoiltGridViewControlsReady) return;
  window.spoiltGridViewControlsReady = true;
  const storageKey = 'spoilt-grid-columns';
  const allowedColumns = ['4', '5', '6'];
  const isTabletOrDesktop = () => window.matchMedia('(min-width: 750px)').matches;
  let columns = '5';
  try {
    const saved = localStorage.getItem(storageKey);
    if (allowedColumns.includes(saved)) columns = saved;
    else localStorage.removeItem(storageKey);
  } catch (_) {}
  const sync = () => {
    const tabletOrDesktop = isTabletOrDesktop();
    document.querySelectorAll('.spoilt-grid-view-page').forEach(root => {
      const grids = root.querySelectorAll('#ProductGridContainer ul.product-grid');
      if (!tabletOrDesktop) {
        root.removeAttribute('data-spoilt-grid-columns');
        grids.forEach(grid => {
          grid.classList.remove('spoilt-grid-controlled');
          grid.removeAttribute('data-spoilt-columns');
          grid.style.removeProperty('--spoilt-grid-columns');
        });
        return;
      }
      root.dataset.spoiltGridColumns = columns;
      grids.forEach(grid => {
        grid.classList.add('spoilt-grid-controlled');
        grid.dataset.spoiltColumns = columns;
        grid.style.setProperty('--spoilt-grid-columns', columns);
      });
      root.querySelectorAll('[data-spoilt-grid-columns]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.spoiltGridColumns === columns));
      });
    });
  };
  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  document.addEventListener('click', event => {
    if (!isTabletOrDesktop()) return;
    const button = event.target.closest('[data-spoilt-grid-columns]');
    if (!button || !button.closest('.spoilt-grid-view-page')) return;
    const next = button.dataset.spoiltGridColumns;
    if (!allowedColumns.includes(next)) return;
    columns = next;
    try { localStorage.setItem(storageKey, columns); } catch (_) {}
    sync();
  });
  const start = () => {
    sync();
    if (document.body) new MutationObserver(scheduleSync).observe(document.body, {childList:true, subtree:true});
  };
  window.addEventListener('resize', scheduleSync, {passive:true});
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', scheduleSync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();